import { PaymentService } from 'src/app/pay/services/payment.service';
import { AnalyticsService } from '../../core/services/analytics-service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { AnalyticsEvent } from 'src/app/core/services/analytics-service';
import { MAX_WIDTH_90, WIDTH_360 } from 'src/app/shared/configs/dialog-config';
import { VerificationStatus } from '../../core/models/verification-status.enum';
import { ApiService } from '../../core/services/api.service';
import { CustomerStoreService } from '../../core/services/customer-store.service';
import { DialogService } from '../../core/services/dialog.service';
import {
  UnverifiedCustomerForAutoPaymentDialogComponent,
} from '../components/unverified-customer-for-auto-payment-dialog/unverified-customer-for-auto-payment-dialog.component';
import { IAutoPayment, IAutoPaymentForm, IBaseAutoPayment } from '../models/auto-payment.model';
import {
  PHONE_VERIFIED_EVENT,
  PhoneNumberEditDialogComponent,
} from 'src/app/shared-dialogs/phone-number-edit-dialog/phone-number-edit-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class AutoPaymentService {
  constructor(
    private apiService: ApiService,
    private dialogService: DialogService,
    private customerStoreService: CustomerStoreService,
    private router: Router,
    private analyticsService: AnalyticsService,
    private paymentService: PaymentService,
  ) {
  }

  public getAutoPayment(autoPaymentId: string): Observable<IAutoPayment> {
    return this.apiService.get<IAutoPayment>(`/automatic-payments/${autoPaymentId}`);
  }

  public getAutoPaymentsByCustomerBillerId(customerBillerId: string): Observable<IAutoPayment[]> {
    return this.apiService.get<IAutoPayment[]>(`/automatic-payments/customer-biller/${customerBillerId}`);
  }

  public createAutoPayment(autoPayments: IAutoPaymentForm): Observable<string[]> {
    return this.apiService.post<string[]>('/automatic-payments', autoPayments);
  }

  public updateAutoPayment(autoPaymentId: string, data: IBaseAutoPayment): Observable<void> {
    return this.apiService.put(`/automatic-payments/${autoPaymentId}`, data);
  }

  public deleteAutoPayment(autoPaymentId: string): Observable<void> {
    return this.apiService.delete(`/automatic-payments/${autoPaymentId}`);
  }

  public setupAutoPayment(createAutoPaymentUrl: string): void {
    const customer = this.customerStoreService.state;
    if (
      customer.verificationStatus === VerificationStatus.PHONE_VERIFIED ||
      customer.verificationStatus === VerificationStatus.IDENTITY_DOCUMENT_VERIFIED
    ) {
      this.router.navigate([createAutoPaymentUrl]);
    } else {
      this.dialogService
        .open(UnverifiedCustomerForAutoPaymentDialogComponent, { width: '457px' })
        .afterClosed()
        .pipe(
          filter((data) => data),
          switchMap(() => this.verifyPhone(createAutoPaymentUrl)),
        )
        .subscribe();
    }
  }

  private verifyPhone(createAutoPaymentUrl: string): Observable<boolean> {
    return this.dialogService
      .open(PhoneNumberEditDialogComponent, {
        maxWidth: MAX_WIDTH_90,
        width: WIDTH_360,
      })
      .afterClosed()
      .pipe(
        filter((data) => data),
        tap(() => {
          this.analyticsService.trackEvent(
            new AnalyticsEvent(PHONE_VERIFIED_EVENT, {
              fromChecklist: false,
            }),
          );
          this.paymentService.refreshBasePayment();
          this.router.navigate([createAutoPaymentUrl]);
        }),
      );
  }
}
